import React from 'react';
import { BoxProps, Flex } from '@withjoy/joykit';
import { DistanceFromVenue } from '@shared/components/DistanceFromVenue';
import { DistanceStatistics } from './DistanceStatistics';

interface VenueAndTravelDistanceProps extends BoxProps {
  milesToVenue?: number | null;
  useShortWordingDistance?: boolean;
}

export const VenueAndTravelDistance = ({ milesToVenue, useShortWordingDistance, ...props }: VenueAndTravelDistanceProps) => {
  return (
    <Flex gap={4} alignItems="center" marginTop={1} {...props}>
      <DistanceFromVenue milesToVenue={milesToVenue} color="mono14" useToWording useShortWording={useShortWordingDistance} />
      <DistanceStatistics milesToVenue={milesToVenue} useShortWording {...props} />
    </Flex>
  );
};
